import { render, staticRenderFns } from "./RecomendationItem.vue?vue&type=template&id=adffe762&scoped=true"
import script from "./RecomendationItem.vue?vue&type=script&lang=js"
export * from "./RecomendationItem.vue?vue&type=script&lang=js"
import style0 from "./RecomendationItem.vue?vue&type=style&index=0&id=adffe762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adffe762",
  null
  
)

export default component.exports